/**
 * Rotating auth-page quote pool.
 * Wrap highlighted text in {curly braces} — rendered in teal on mobile hero.
 * Tagline split by \n: first line = gray, second line = teal.
 */
const QUOTES = [
  {
    headline: "Every small step today\nbuilds a {brighter tomorrow}\nfor your child.",
    tagline: "You're not just parenting,\nyou're shaping a future.",
  },
  {
    headline: "Little moments of connection\nbecome a lifetime\n{of confidence.}",
    tagline: "The best learning\nbegins with love.",
  },
  {
    headline: "Progress isn't perfect.\nIt's one small victory\n{at a time.}",
    tagline: "Celebrate\nevery little win.",
  },
  {
    headline: "Every child grows differently.\nEvery journey\n{deserves support.}",
    tagline: "We're here\nfor every step.",
  },
  {
    headline: "Play today.\nWatch confidence\n{grow tomorrow.}",
    tagline: "Simple activities.\nLifelong impact.",
  },
  {
    headline: "Small moments.\n{Big milestones.}",
    tagline: "The little things\nmatter most.",
  },
  {
    headline: "A few minutes today\ncan inspire a lifetime\n{of learning.}",
    tagline: "Consistency\ncreates change.",
  },
  {
    headline: "Behind every confident child\nis someone who\n{believed first.}",
    tagline: "Thank you\nfor showing up today.",
  },
  {
    headline: "Growing together\none activity,\n{one smile at a time.}",
    tagline: "Every moment\ncounts.",
  },
  {
    headline: "Your love is enough.\nWe're here to guide\n{the journey.}",
    tagline: "Let's help\nyour child thrive.",
  },
];

export function getRandomQuote() {
  return QUOTES[Math.floor(Math.random() * QUOTES.length)];
}

/**
 * Splits a headline string on {highlight} markers and returns an array of
 * React-renderable parts: plain strings alternate with { teal: true, text }.
 * Caller maps these to JSX.
 */
export function parseHeadline(text) {
  return text.split(/\{([^}]+)\}/).map((part, i) => ({
    teal: i % 2 === 1,
    text: part,
  }));
}
